import { BUYER_PROFILE_LINKS } from '../constants/links';
import { canManageCreditCard } from './creditCard';

export const parseBuyerProfileTabs = user => {
  if (!canManageCreditCard(user?.buyer)) return BUYER_PROFILE_LINKS.filter((_, i) => i !== 2);
  return BUYER_PROFILE_LINKS;
};
